import { render, staticRenderFns } from "./SwitchProfile.vue?vue&type=template&id=1d332a58"
import script from "./SwitchProfile.vue?vue&type=script&lang=js"
export * from "./SwitchProfile.vue?vue&type=script&lang=js"
import style0 from "./SwitchProfile.vue?vue&type=style&index=0&id=1d332a58&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports